import apiClient from './client';
import type { Question } from '../types';

/** A flagged ("for review") question: full question payload + personal note. */
export interface FlaggedQuestion extends Question {
  note: string | null;
  flagged_at: string;
}

interface FlaggedList {
  total: number;
  items: FlaggedQuestion[];
}

/** Full flagged questions (with answer + explanation) for the review screen. */
export async function fetchFlaggedQuestions(): Promise<FlaggedList> {
  const { data } = await apiClient.get<FlaggedList>('/api/flagged');
  return data;
}

/** Lightweight list of flagged question ids — for in-session toggle state. */
export async function fetchFlaggedIds(): Promise<number[]> {
  const { data } = await apiClient.get<{ ids: number[] }>('/api/flagged/ids');
  return data.ids;
}

/** Flag a question for review (idempotent). Optional exam-tip note. */
export async function flagQuestion(questionId: number, note?: string): Promise<void> {
  await apiClient.post(`/api/flagged/${questionId}`, note != null ? { note } : {});
}

/** Set (or clear) the note on an already-flagged question. */
export async function updateFlagNote(questionId: number, note: string | null): Promise<void> {
  await apiClient.patch(`/api/flagged/${questionId}`, { note });
}

/** Remove a flag. */
export async function unflagQuestion(questionId: number): Promise<void> {
  await apiClient.delete(`/api/flagged/${questionId}`);
}
